export default {
  person: 'person',
  company: 'company',
};
